import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { AuthError } from '@juvare/platform-app/App';
import { implementTypedPlatformFunction } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions';
import { createBadgeHistoryEntry } from '../utils/createBadgeHistoryEntry';
import { logBadgeHistoryActionFunctionDef, } from './logBadgeHistoryActionSchema';
export const logBadgeHistoryActionFunctionImpl = implementTypedPlatformFunction(logBadgeHistoryActionFunctionDef, logBadgeHistoryAction);
export function logBadgeHistoryAction(context, req) {
    if (!requireAnySystemPermission(context.userState, 'manage-badges', 'manage-account-badges')) {
        throw new AuthError('Unauthorized');
    }
    createBadgeHistoryEntry(context, {
        accountBadgeIds: req.accountBadgeIds,
        badgeId: req.badgeId,
        action: req.action,
        createdBy: context.userState.id,
        createdByEmail: context.userState.email,
        createdByRole: context.userState.systemRole,
    });
    return { success: true };
}
